import { Injectable, ViewContainerRef, ElementRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Modal, ModalMO, ModalNG } from './modal.model';
import { Constructor } from '@angular/material/core/typings/common-behaviors/constructor';

export abstract class ModalComponent<T> {
	modalRef: Modal<T> = null;
}

@Injectable()
export class ModalService {
	private observerNav: MutationObserver;
	private observerModal: MutationObserver;
	private modalRef: NgbModalRef;
	activeModal: Modal<any>;

	constructor(private modalService: NgbModal) { }

	// Use the mutationObserver
	open<T>(content: Constructor<ModalComponent<T>>, vRef: ViewContainerRef, options?: NgbModalOptions): Modal<T>;
	// Use the PopStateEvent
	open<T>(content: Constructor<ModalComponent<T>>, options?: NgbModalOptions): Modal<T>;

	open<T>(content: Constructor<ModalComponent<T>>, vRefOrOptions: ViewContainerRef | NgbModalOptions, options?: NgbModalOptions) {
		if (vRefOrOptions && this.isViewContainerRef(vRefOrOptions)) {
			this.activeModal = new ModalMO<T>(this.modalService.open(content, options), vRefOrOptions);
		} else {
			this.activeModal = new ModalNG<T>(this.modalService.open(content, <NgbModalOptions>vRefOrOptions));
		}

		this.activeModal.componentInstance.modalRef = this.activeModal;

		return this.activeModal;
	}

	private isViewContainerRef(value: any): value is ViewContainerRef {
		return (value.constructor) && value.constructor.name === 'ViewContainerRef_';
	}
}

@Injectable()
export class ActiveModalService {
	constructor(private modalService: ModalService) {}

	close(result?: any): void {
		this.modalService.activeModal.close(result);
		this.modalService.activeModal = null;
	}

	dismiss(reason?: any): void {
		this.modalService.activeModal.dismiss(reason);
		this.modalService.activeModal = null;
	}

	get componentInstance(): any {
		return this.modalService.activeModal.componentInstance;
	}

	get result(): Promise<any> {
		return this.modalService.activeModal.result;
	}
}
